(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;

        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /*
    Langford Accordion Menu - Versión definitiva
    - Cierra todos los submenús internos al cargar.
    - Abre solo el submenú interno clickeado.
    - Cierra los submenús hermanos automáticamente.
    - Usa .langford-open para controlar visibilidad real.
  */

  class LangfordAccordionMenu {
    constructor() {
      this.header = document.querySelector('.section-header');
      this.init();
    }

    init() {
      if (!this.header) return;

      this.resetAllNestedMenus();
      this.bindTopLevelMenus();
      this.bindNestedMenus();
      this.bindDrawerMenus();
      this.bindOutsideClick();
      this.bindEscapeKey();
    }

    resetAllNestedMenus() {
      const nestedDetails = this.header.querySelectorAll('.header__submenu details');

      nestedDetails.forEach((details) => {
        details.removeAttribute('open');
        details.classList.remove('langford-open');

        const summary = details.querySelector(':scope > summary');

        if (summary) {
          summary.setAttribute('aria-expanded', 'false');
          summary.setAttribute('role', 'button');
        }
      });
    }

    bindTopLevelMenus() {
      const topLevelDetails = this.header.querySelectorAll(
        '.header__inline-menu > ul > li > header-menu > details, .header__inline-menu > ul > li > details'
      );

      topLevelDetails.forEach((details) => {
        const summary = details.querySelector(':scope > summary');

        if (!summary) return;

        summary.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const wasOpen = details.hasAttribute('open');

          this.closeAllTopLevelMenus(details);

          if (wasOpen) {
            details.removeAttribute('open');
          } else {
            details.setAttribute('open', '');
          }

          this.resetAllNestedMenus();
        }, true);
      });
    }

    bindNestedMenus() {
      const nestedSummaries = this.header.querySelectorAll('.header__submenu details > summary');

      nestedSummaries.forEach((summary) => {
        summary.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const currentDetails = summary.closest('details');

          if (!currentDetails) return;

          const isOpen = currentDetails.classList.contains('langford-open');

          this.closeSiblingNestedMenus(currentDetails);

          if (isOpen) {
            currentDetails.classList.remove('langford-open');
            currentDetails.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          } else {
            currentDetails.classList.add('langford-open');
            currentDetails.setAttribute('open', '');
            summary.setAttribute('aria-expanded', 'true');
          }
        }, true);
      });
    }

    bindDrawerMenus() {
      const drawerDetails = this.header.querySelectorAll('.menu-drawer details');

      drawerDetails.forEach((details) => {
        const summary = details.querySelector(':scope > summary');

        if (!summary) return;

        summary.addEventListener('click', (event) => {
          event.stopPropagation();

          setTimeout(() => {
            if (details.hasAttribute('open')) {
              this.closeSiblingNestedMenus(details);
              summary.setAttribute('aria-expanded', 'true');
            } else {
              summary.setAttribute('aria-expanded', 'false');
            }
          }, 0);
        }, true);
      });
    }

    closeSiblingNestedMenus(currentDetails) {
      const parentListItem = currentDetails.parentElement;

      if (!parentListItem) return;

      const parentList = parentListItem.parentElement;

      if (!parentList) return;

      const siblingDetails = parentList.querySelectorAll(':scope > li > details, :scope > details');

      siblingDetails.forEach((details) => {
        if (details !== currentDetails) {
          this.closeNestedMenu(details);
        }
      });
    }

    closeNestedMenu(details) {
      details.classList.remove('langford-open');
      details.removeAttribute('open');

      const summary = details.querySelector(':scope > summary');

      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
      }

      const children = details.querySelectorAll('details');

      children.forEach((child) => {
        child.classList.remove('langford-open');
        child.removeAttribute('open');

        const childSummary = child.querySelector(':scope > summary');

        if (childSummary) {
          childSummary.setAttribute('aria-expanded', 'false');
        }
      });
    }

    closeAllTopLevelMenus(exception = null) {
      const topLevelDetails = this.header.querySelectorAll(
        '.header__inline-menu > ul > li > header-menu > details, .header__inline-menu > ul > li > details'
      );

      topLevelDetails.forEach((details) => {
        if (details !== exception) {
          details.removeAttribute('open');
        }
      });
    }

    closeAllMenus() {
      const allOpenDetails = this.header.querySelectorAll('.header__inline-menu details');

      allOpenDetails.forEach((details) => {
        details.removeAttribute('open');
        details.classList.remove('langford-open');

        const summary = details.querySelector(':scope > summary');

        if (summary) {
          summary.setAttribute('aria-expanded', 'false');
        }
      });
    }

    bindOutsideClick() {
      document.addEventListener('click', (event) => {
        const clickedInsideHeader = event.target.closest('.section-header');

        if (!clickedInsideHeader) {
          this.closeAllMenus();
        }
      });
    }

    bindEscapeKey() {
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.closeAllMenus();
        }
      });
    }
  }

  function initLangfordAccordionMenu() {
    new LangfordAccordionMenu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLangfordAccordionMenu);
  } else {
    initLangfordAccordionMenu();
  }

  document.addEventListener('shopify:section:load', initLangfordAccordionMenu);

  } catch(e) { console.error(e); }
})();
})();
